<div class="note-container" *ngIf="showNote" [ngClass]="data?.class">
  <div class="note-title">{{ clauseText }} clause</div>
  <div class="note-subtitle">{{ staticText }}</div>
</div>
